import ExcelController from "./excelController";

export default class StorageController {

    static setGlobal(key: string, value: string|null) {
        if (value) {
            localStorage.setItem(key, value);
        } else {
            localStorage.removeItem(key);
        }
    }

    static getGlobal(key: string): string|null {
        return localStorage.getItem(key);
    }

    static set(key: string, value: string|null) {
        if (value) {
            Office.context.document.settings.set(this.scopedDocumentKey(key), value);
        } else {
            Office.context.document.settings.remove(this.scopedDocumentKey(key));
        }
        Office.context.document.settings.saveAsync();
        this.setGlobal(this.scopedLocalKey(key), value);
    }

    static get(key: string): string|null {
        let ret = Office.context.document.settings.get(this.scopedDocumentKey(key));
        if (!ret) {
            ret = this.getGlobal(this.scopedLocalKey(key));
        }
        return ret;
    }

    private static scopedDocumentKey(key: string): string {
        return "F19." + key;
    }

    private static scopedLocalKey(key: string): string {
        return key + "_" + ExcelController.fileName();
    }
}